import {
  LOGIN,
  LOGIN_FAILURE,
  LOGOUT,
  REGISTER,
  REGISTER_FAILURE,
} from "store/types";
import axios from "configs/axios";
import { handleSwal } from "utils/sweetAlert";

export const login = (data) => {
  return async (dispatch) => {
    dispatch({
      type: LOGIN,
      payload: {
        loading: true,
        data: false,
        errorMessage: false,
      },
      user: false,
    });

    try {
      const loginResponse = await axios.post(
        `${process.env.REACT_APP_HOST}/api/v1/login`,
        data
      );
      await dispatch(fetchLogin(loginResponse));
    } catch (error) {
      await dispatch(loginFailure(error));
    }
  };
};

export const loginGoogle = (access_token) => {
  return async (dispatch) => {
    dispatch({
      type: LOGIN,
      payload: {
        loading: true,
        data: false,
        errorMessage: false,
      },
      user: false,
    });

    const data = {
      access_token,
    };

    try {
      // post to login
      const loginResponse = await axios.post(
        `${process.env.REACT_APP_HOST}/api/v1/google`,
        data
      );

      await dispatch(fetchLogin(loginResponse));
    } catch (error) {
      await dispatch(loginFailure(error));
    }
  };
};

export const logout = () => {
  return (dispatch) => {
    dispatch({
      type: LOGOUT,
    });
    handleSwal("Logout Successful!", "success");
  };
};

// REGISTER
export const register = (data) => {
  return async (dispatch) => {
    dispatch({
      type: REGISTER,
      payload: {
        loading: true,
        data: false,
        errorMessage: false,
      },
    });

    try {
      // post to register
      const registerResponse = await axios.post(
        `${process.env.REACT_APP_HOST}/api/v1/register`,
        data
      );

      // Dispatch register success action
      dispatch({
        type: REGISTER,
        payload: {
          loading: false,
          data: registerResponse.data,
          errorMessage: false,
        },
      });
      handleSwal("Register Successful! Please Login!", "success");
    } catch (error) {
      // Dispatch register failure action
      dispatch({
        type: REGISTER_FAILURE,
        payload: {
          loading: false,
          data: false,
          errorMessage: error.response.data.message,
        },
      });
      handleSwal(error.response.data.message, "error");
    }
  };
};

// Fetch Login
export const fetchLogin = (loginResponse) => async (dispatch) => {
  // Dispatch login success action
  dispatch({
    type: LOGIN,
    payload: {
      loading: false,
      data: loginResponse.data.accessToken,
      errorMessage: false,
    },
    user: false,
  });
  handleSwal("Login Successful!", "success");

  // get profile after successful login
  const profileResponse = await axios.get(
    `${process.env.REACT_APP_HOST}/api/v1/profile`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }
  );

  // Dispatch profile success action
  dispatch({
    type: LOGIN,
    payload: {
      loading: false,
      data: loginResponse.data.accessToken,
      errorMessage: false,
    },
    user: profileResponse.data,
  });
};

// Login Error
export const loginFailure = (error) => async (dispatch) => {
  dispatch({
    type: LOGIN_FAILURE,
    payload: {
      loading: false,
      data: false,
      errorMessage: error.message,
    },
    user: false,
  });
  handleSwal(error.response.data.message, "error");
};
